/**
 * Footer columns stagger up together as the footer scrolls into view —
 * same treatment previously applied generically via furlouve-scroll-reveal.js
 * (now unused, since the real footer content lives in this dedicated
 * section rather than an AI-gen block).
 */
import { revealOnScroll } from '@theme/premium-motion';

revealOnScroll('.flv-footer__col', { y: 24, scale: 1, duration: 0.7, stagger: 0.08 });
